import * as React from "react";
const InstaSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={50}
    height={50}
    fill="none"
    {...props}
  >
    <rect width={49} height={49} x={0.5} y={0.5} stroke="#FAFBFC" rx={24.5} />
    <path
      fill="#fff"
      d="M25 18.446h3.277c.771 0 1.157.193 1.446.289.385.193.675.29.964.578.289.29.482.579.578.964.096.29.193.675.29 1.446v6.554c0 .771-.194 1.157-.29 1.446-.193.385-.29.675-.578.964-.29.289-.579.482-.964.578-.29.096-.675.193-1.446.29h-6.554c-.771 0-1.157-.194-1.446-.29-.385-.193-.675-.29-.964-.578-.289-.29-.482-.579-.578-.964-.096-.29-.193-.675-.29-1.446v-6.554c0-.771.194-1.157.29-1.446.193-.385.29-.675.578-.964.29-.289.579-.482.964-.578.29-.096.675-.193 1.446-.29H25ZM25 17h-3.277c-.868 0-1.446.193-1.928.386a4.21 4.21 0 0 0-1.446.963c-.482.482-.674.868-.963 1.446-.193.482-.29 1.06-.386 1.928v6.554c0 .868.193 1.446.386 1.928.192.482.482.964.963 1.446.482.482.868.674 1.446.963.482.193 1.06.29 1.928.386h6.554c.868 0 1.446-.193 1.928-.386a4.21 4.21 0 0 0 1.446-.963c.482-.482.674-.868.963-1.446.193-.482.29-1.06.386-1.928v-6.554c0-.868-.193-1.446-.386-1.928a4.21 4.21 0 0 0-.963-1.446c-.482-.482-.868-.674-1.446-.963-.482-.193-1.06-.29-1.928-.386H25Z"
    />
    <path
      fill="#fff"
      d="M25 20.855A4.114 4.114 0 0 0 20.855 25 4.114 4.114 0 0 0 25 29.145 4.114 4.114 0 0 0 29.145 25 4.114 4.114 0 0 0 25 20.855Zm0 6.844A2.694 2.694 0 0 1 22.301 25 2.694 2.694 0 0 1 25 22.301 2.694 2.694 0 0 1 27.699 25c0 1.446-1.253 2.699-2.699 2.699ZM29.241 21.723a.964.964 0 1 0 0-1.928.964.964 0 0 0 0 1.928Z"
    />
  </svg>
);
export default InstaSVG;
